<script lang="ts">
  import { openModal } from '$lib/stores/modals.store';
  import { createEventDispatcher } from 'svelte';

  import { slide } from 'svelte/transition';
  let menuVisible: boolean = false;
  let klazz = 'fixed';
  export { klazz as class };
  export let links: { href: string; text: string; target?: string }[] = [
    { text: 'For Teachers', href: '/teach/' },
    { text: 'Lessons', href: 'https://utheory.com/app/lessons/list' },
    { text: 'Practice', href: 'https://utheory.com/app/skills' },
    { text: 'Printable Resources', href: '/teach/resources' },
    { text: 'Our Team', href: 'https://info.utheory.com/about-us/' },
    { text: 'About', href: 'https://info.utheory.com/about' },
    { text: 'Blog', href: 'https://info.utheory.com' },
  ];

  const dispatch = createEventDispatcher<{ hide: null }>();

  export const toggle = () => {
    menuVisible = !menuVisible;
  };

  export const set = (open: boolean) => {
    menuVisible = open;
  };

  const hide = () => {
    menuVisible = false;
    dispatch('hide');
  };

  const hideOnEscape = (evt: KeyboardEvent) => {
    if (menuVisible && evt.key === 'Escape') {
      hide();
      evt.stopPropagation();
    }
  };
</script>

<svelte:window on:mousedown={hide} on:touchstart={hide} on:keydown={hideOnEscape} />

{#if menuVisible}
  <div
    on:mousedown={(evt) => {
      evt.stopPropagation();
    }}
    on:touchstart={(evt) => {
      evt.stopPropagation();
    }}
  >
    <nav
      class="w-full h-full overflow-y-scroll xs:h-auto xs:w-72 border border-gray-light shadow-lg bg-white xs:right-0 z-20 py-6 px-4 text-left {klazz}"
      transition:slide|local
    >
      <div class="block text-right">
        <button on:touchstart={hide} on:mousedown={hide} on:click={hide}>
          <img src="/teach/t-landing/icon-off-canvas-menu-close.svg" alt="Close Menu" />
          <span class="sr-only">Close Menu</span>
        </button>
      </div>
      <ul class="text-gray-light text-base md:text-lg text-left mb-4 md:mb-6">
        {#each links as { text, href }}
          <li>
            <a on:click={hide} {href}>{text}</a>
          </li>
        {/each}
      </ul>

      <a href="/app" class="text-gray font-semibold underline text-sm block mb-4"
        >Start Learning ></a
      >
      <button
        on:click={() => openModal('register')}
        class="text-gray font-semibold underline text-sm block mb-4"
        >Create a Free Teacher Account ></button
      >

      <button on:click={() => openModal('login')} class="btn-green">Sign In</button>
    </nav>
  </div>
{/if}

<style lang="postcss">
  li {
    @apply block py-3;
  }
</style>
